import config from "./config";

(function($) {
    $(window).on("load",function () {
        const {Chart, truncateLabel, barChartConfig} = config
        const isNonComplianceReport = $('.result-chart--non-compliance').length > 0;
        
        const renderMaturityLevelChart  = (data) => {
            const pillarValue = $('#edit-pillar').val();
            const referenceLevel = data.general_information?.reference_maturity_level || 0;
            const valueAchieved = pillarValue === 'all' ? data.general_information?.average_maturity : data[pillarValue]?.maturity_level;
            const ctx_chart = $('#ctx_barChart_value-archieved-reference');

            const config = barChartConfig('Maturity Level - Value achieved and reference value');
            config.options.plugins.legend.display = false;
            config.options.plugins.title.display = false;

            new Chart(ctx_chart, {
                ...config,
                data: {
                    labels: ["Reference Level", "Inputs"],
                    datasets: [
                        { 
                            barThickness: 100,
                            data: [
                                referenceLevel || 0,
                                valueAchieved || 0,
                            ],
                            backgroundColor: ['#096E7C', '#AE0F0F']
                        },
                    ],
                }
            });
        }

        const renderNonComplianceChart = (data) => {
            const pillarValue = $('#edit-pillar').val();
            const pillarText = $('#edit-pillar option:selected').text();
            const ctx_chart = $('#ctx_barChart_non-compliance');
            const chartData = Object.values(pillarValue === 'all' ? data.general_information.non_compliance_results : data[pillarValue].non_compliance_results);
            const getMaxValue = chartData.length > 0 ? Math.max(...chartData) : 120;
            const maxValue = getMaxValue % 5 === 0 ? getMaxValue + 5 : Math.ceil(getMaxValue / 5) * 5

            const config = barChartConfig('Frequency of root causes', 0, maxValue, 5);
            config.options.plugins.title.display = false;

            new Chart(ctx_chart, {
                ...config,
                data: {
                    labels: [pillarText],
                    datasets: [
                        { label: data.priorities['21'], data: [chartData[0]], backgroundColor: '#AE0F0F', barPercentage: 0.6 },
                        { label: data.priorities['22'], data: [chartData[1]], backgroundColor: '#BE6A48', barPercentage: 0.6 },
                        { label: data.priorities['23'], data: [chartData[2]], backgroundColor: '#00EFC1', barPercentage: 0.6 },
                        { label: data.priorities['24'], data: [chartData[3]], backgroundColor: '#06A097', barPercentage: 0.6 },
                        { label: data.priorities['25'], data: [chartData[4]], backgroundColor: '#096E7C', barPercentage: 0.6 }
                    ],
                }
            });

        }

        const updateCharts = (event, data) => {
            const pillarValue = $(event.currentTarget).val();
            const pillarText = $(event.currentTarget).find('option:selected').text();
            const referenceLevel = data.general_information?.reference_maturity_level || 0;
            const valueAchieved = pillarValue === 'all' ? data.general_information?.average_maturity : data[pillarValue]?.maturity_level;
            const nonComplianceResults = Object.values(pillarValue === 'all' ? data.general_information.non_compliance_results : data[pillarValue]?.non_compliance_results || 0);
            const maxValue = nonComplianceResults.length > 0 ? Math.max(...nonComplianceResults) : 20;

            const ctx_maturityLevelChart  = Chart.getChart('ctx_barChart_value-archieved-reference');
            const ctx_nonComplianceChart  = Chart.getChart('ctx_barChart_non-compliance');

            ctx_maturityLevelChart.options.animation = true;
            ctx_maturityLevelChart.data.datasets[0].data = [referenceLevel || 0, valueAchieved || 0];
            ctx_maturityLevelChart.update();

            ctx_nonComplianceChart.options.animation = true;
            ctx_nonComplianceChart.options.scales.y.max = maxValue % 5 === 0 ? maxValue + 5 : Math.ceil(maxValue / 5) * 5;
            ctx_nonComplianceChart.data.labels[0] = pillarText;
            ctx_nonComplianceChart.data.datasets.forEach((item, index) => {
                item.data = [nonComplianceResults[index]];
            });
            ctx_nonComplianceChart.update();
        }

        const setMaturityLevel = (data) => {
            $('#validation-maturity-level').hide();
            const pillarValue = $('#edit-pillar').val();
            const maturityLevel = pillarValue === 'all' ? data.general_information?.average_maturity : data[pillarValue]?.maturity_level;
            
            if (maturityLevel >= 0) {
                $('.maturity-level').text(maturityLevel);
            } else {
                $('.maturity-level').text('N/A');
                $('#validation-maturity-level').text(`Please fill in pillar ${pillarValue.split('_')[1]} in order to use the non-compliance report.`);
                $('#validation-maturity-level').show();
            }
        }

        const renderNonComplianceTable = (data) => {
            const pillarValue = $('#edit-pillar').val();
            const table = $('.non-comliance-table');
            const tbody = table.find('tbody');
            tbody.empty();

            data
                .filter(item => pillarValue !== 'all' ? item.pillar === Number(pillarValue.split('_')[1]) : true)
                .forEach((item, index) => {
                    const rows = [
                        $(`<td>${item.pillar}</td>`),
                        $(`<td data-cell="requirement_number">
                            <span>${item.requirement_number}</span>
                            <span class="info-icon" aria-controls="info-${index}" aria-expanded="false" role="button">
                                <span class="info-${index}">Info</span>
                            </span>
                        </td>`),
                        $(`<td>${item.requirement}</td>`),
                        $(`<td>${item.priority1 || ' '}</td>`),
                        $(`<td>${item.priority2 || ' '}</td>`),
                        $(`<td>${item.priority3 || ' '}</td>`),
                        $(`<td>${item.comment}</td>`),
                    ];

                    $('body').append(`
                        <div class="info-layer" id="info-${index}">
                            <div class="info-close">close</div>
                            <div>
                                <p>
                                    <strong>Area</strong> <br>
                                    ${item.area}
                                </p>
                                <p>
                                    <strong>Reference</strong> <br>
                                    ${item.reference}
                                </p>
                                <p>
                                    <strong>Description</strong> <br>
                                    ${item.description}
                                </p>
                            </div>
                        </div>
                    `)

                    const tr = $(`<tr data-pillar="${item.pillar}">`);
                    rows.forEach((el) => { 
                        tr.append(el);
                        tbody.append(tr);
                    })
                });
            
            $(".info-close").on( "click", function() {
                $('.' + $(this).parent(".info-layer").attr("id") ).parent().attr('aria-expanded', "false");

                $(this).parent(".info-layer").fadeOut();
            });
                
            $(".info-icon").on( "click", function() {
                $(".info-layer").fadeOut();
                $(".info-icon").attr('aria-expanded', "false");

                $(this).attr('aria-expanded', "true");
                $('#' + $(this).find('span').attr("class")).fadeIn();
            });
        }

        const handleTableExport = (event) => {
            const el = event.currentTarget;
            const pillarValue = $('#edit-pillar').val();

            el.href = `/non_compliance_report?${pillarValue !== 'all' ? `pillar=${pillarValue}&` : ''}onlyNotMetRequirements=1&format=csv`;
        }

        const handleChartExport = (event) => {
            const el = event.currentTarget;
            const chart = document.querySelector(`#${el.getAttribute('data-chart-ref')}`);
            const chartObject = Chart.getChart(`${el.getAttribute('data-chart-ref')}`);

            chartObject.options.plugins.legend.display = el.getAttribute('data-chart-ref') !== 'ctx_barChart_value-archieved-reference';
            chartObject.options.plugins.title.display = true;
            chartObject.update();
     
            el.download = `${chart.getAttribute('aria-label')}.jpeg`
            el.href = chart.toDataURL("image/jpeg", 1.0);

            chartObject.options.plugins.legend.display = false;
            chartObject.options.plugins.title.display = false;
            chartObject.update();
        }

        const init = () => {
            $.ajax({
                url: '/submission_jsons',
                type: 'GET',
                success: res => {
                    setMaturityLevel(res)
                    renderMaturityLevelChart(res);
                    renderNonComplianceChart(res);

                    $('.result-chart-container').css({ opacity: 1 });
                    $('.spinner-container').hide();

                    $('#edit-pillar').on('change', (event) => {
                        setMaturityLevel(res);
                        updateCharts(event, res);
                    });
                }
            });

            $.ajax({
                url: `/non_compliance_report?onlyNotMetRequirements=1&format=json`,
                type: 'GET',
                success: res => {
                    renderNonComplianceTable(res);
                    $('.result-table-container').show();

                    $('#edit-pillar').on('change', () => {
                        renderNonComplianceTable(res);
                    });

                }
            })

            $('.table-export').on('click', handleTableExport)
            $(".chart-export").on('click', handleChartExport)
            
        }

        if (isNonComplianceReport) init();
    });
}(jQuery));